import { DirectionEnum, ICoursesCalendarSlotDto } from "@ryde/shared";

const escapeCsv = (value: string): string => {
  if (value.includes('"') || value.includes(",") || value.includes("\n")) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

const directionLetter = (d: DirectionEnum): string => {
  if (d === DirectionEnum.PickUp) {
    return "A";
  }
  if (d === DirectionEnum.DropOff) {
    return "B";
  }
  return "";
};

export const coursesCalendarSlotsToCsv = (
  slots: ICoursesCalendarSlotDto[],
): string => {
  const headers = [
    "courseId",
    "courseName",
    "dateKey",
    "timeLabel",
    "direction",
    "hasRide",
    "rideId",
    "rideStatus",
    "originStationName",
    "destinationStationName",
    "potentialPassengerCount",
  ];
  const lines = [headers.join(",")];
  for (const s of slots) {
    const row = [
      String(s.courseId),
      escapeCsv(s.courseName ?? ""),
      s.dateKey,
      s.timeLabel,
      directionLetter(s.direction),
      s.hasRide ? "1" : "0",
      s.rideId !== undefined ? String(s.rideId) : "",
      s.rideStatus !== undefined ? String(s.rideStatus) : "",
      escapeCsv(s.originStationName ?? ""),
      escapeCsv(s.destinationStationName ?? ""),
      String(s.potentialPassengerCount),
    ];
    lines.push(row.join(","));
  }
  return lines.join("\n");
};

export const coursesCalendarCsvFilename = (): string => {
  const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
  return `courses-calendar-${stamp}.csv`;
};

export const downloadCoursesCalendarSlotsCsv = (
  slots: ICoursesCalendarSlotDto[],
): void => {
  const csv = coursesCalendarSlotsToCsv(slots);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", coursesCalendarCsvFilename());
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
